var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionPremium2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_42865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 8.02219 19.4135 6.08879 18.3147 4.4443C17.2159 2.79981 15.6541 1.51809 13.8268 0.761209C11.9996 0.00433251 9.98891 -0.193701 8.0491 0.192151C6.10929 0.578003 4.32746 1.53041 2.92893 2.92894C1.53041 4.32746 0.577999 6.10929 0.192146 8.0491C-0.193705 9.98891 0.00432725 11.9996 0.761203 13.8268C1.51808 15.6541 2.7998 17.2159 4.4443 18.3147C6.08879 19.4135 8.02219 20 10 20C12.6513 19.9971 15.1932 18.9426 17.0679 17.0679C18.9426 15.1932 19.9971 12.6513 20 10ZM1.66667 10C1.66667 8.35183 2.15541 6.74066 3.07109 5.37025C3.98676 3.99984 5.28825 2.93174 6.81097 2.30101C8.33369 1.67028 10.0092 1.50525 11.6258 1.82679C13.2423 2.14834 14.7271 2.94201 15.8926 4.10745C17.058 5.27289 17.8517 6.75774 18.1732 8.37425C18.4948 9.99076 18.3297 11.6663 17.699 13.189C17.0683 14.7118 16.0002 16.0132 14.6298 16.9289C13.2593 17.8446 11.6482 18.3333 10 18.3333C7.79061 18.3309 5.6724 17.4522 4.11012 15.8899C2.54785 14.3276 1.66909 12.2094 1.66667 10Z",
    fill: "#E2E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.99998C16.6667 9.88947 16.6228 9.78349 16.5447 9.70535C16.4666 9.62721 16.3606 9.58331 16.2501 9.58331L10.4167 9.58331L10.4167 3.74998C10.4167 3.63947 10.3728 3.53349 10.2947 3.45535C10.2166 3.37721 10.1106 3.33331 10.0001 3.33331C8.68154 3.33331 7.39261 3.72431 6.29628 4.45685C5.19995 5.18939 4.34547 6.23058 3.84088 7.44876C3.3363 8.66693 3.20428 10.0074 3.46151 11.3006C3.71875 12.5938 4.35369 13.7817 5.28604 14.714C6.21839 15.6464 7.40627 16.2813 8.69948 16.5385C9.99269 16.7958 11.3331 16.6638 12.5513 16.1592C13.7695 15.6546 14.8107 14.8001 15.5432 13.7038C16.2758 12.6075 16.6667 11.3185 16.6667 9.99998Z",
    fill: "#E2E8EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_42865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionPremium2);
export default __webpack_public_path__ + "static/media/optionPremium2.650bc80114175117e30973f7b8b23f2f.svg";
export { ForwardRef as ReactComponent };